import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import Eyebrow from '../modules/components/Eyebrow';

const areas = [
  {
    name: '埼玉県',
    cities: '飯能市 日高市 入間市 狭山市 所沢市 川越市（その他 要相談）',
    map: '/images/AreaSaitama.svg',
    alt: '埼玉県対応エリア',
  },
  {
    name: '東京都',
    cities: '青梅市 羽村市 瑞穂町 武蔵村山市（その他 要相談）',
    map: '/images/AreaTokyo.svg',
    alt: '東京都対応エリア',
  },
];

function Area() {
  return (
    <Section bg="paper">
      <Box sx={{ textAlign: 'center', mb: { xs: 5, sm: 8 } }}>
        <Eyebrow>Area</Eyebrow>
        <Typography variant="h2" component="h2">
          対応エリア
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: { xs: 6, sm: 7 },
          maxWidth: 920,
          mx: 'auto',
        }}
      >
        {areas.map((area) => (
          <Box key={area.name} sx={{ textAlign: 'center' }}>
            <Typography variant="h3" component="h3" sx={{ letterSpacing: '.14em', mb: 1 }}>
              {area.name}
            </Typography>
            <Typography sx={{ fontSize: 14.5, color: 'text.secondary', mb: 3 }}>{area.cities}</Typography>
            <Box component="img" src={area.map} alt={area.alt} sx={{ width: '100%', maxWidth: 340 }} />
          </Box>
        ))}
      </Box>

      <Typography sx={{ textAlign: 'center', fontSize: 11, color: 'text.secondary', mt: 5 }}>
        地図提供: d-maps.com
      </Typography>
    </Section>
  );
}

export default Area;
